<template>
  <div class="file-size">
      <el-input-number v-bind="$props" v-model="currentValue" @change="changeVal" placeholder="请输入" :controls="false" :precision="2" :min="0" :max="52430000"></el-input-number>
      <span style="margin-left:10px;">{{getfilesize(value)}}</span>
      <span class="tip">文件最大限制为50MB</span>
  </div>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {

    }
  },
  computed: {
    currentValue: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  methods: {
    changeVal(val, lr) {
        this.$emit('change', val, lr)
    },
    getfilesize(size) {
      if (!size) return "";
      var num = 1024.00; //byte
      if (size < num)
        return size + "B";
      if (size < Math.pow(num, 2))
        return (size / num).toFixed(2) + "KB"; //kb
      if (size < Math.pow(num, 3))
        return (size / Math.pow(num, 2)).toFixed(2) + "MB"; //M
      if (size < Math.pow(num, 4))
        return (size / Math.pow(num, 3)).toFixed(2) + "G"; //G
      return (size / Math.pow(num, 4)).toFixed(2) + "T"; //T
    }
  }
}
</script>

<style lang="scss">
.file-size{
  .tip{
    color:#ccc;
    font-size: 12px;
    margin-left:10px;
  }
}
</style>
